exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.scroll-section[data-v-369ca564]{position:absolute;left:0;right:0;background-image:none!important}div.scroll-section>div.section-background[data-v-369ca564]{background-color:transparent!important}div.scroll-section>a[data-v-369ca564]{position:absolute;left:50%;width:50px;margin-left:-25px;color:#fff}div.scroll-section>a.prev-link[data-v-369ca564]{top:5px}div.scroll-section>a.next-link[data-v-369ca564]{bottom:5px}div.shared-section>div.section-inner[data-v-369ca564]{z-index:1000}div.inline-section>div.section-inner[data-v-369ca564]{z-index:1100}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-369ca564","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ScrollSection.vue
// module id = 283
// module chunks = 0